<template>
    <div id="ticket-component">
        <AppBreadCrumb :paths="[{ title: $t('message.ticket') }]" :select="true">
            <div v-if="tabIndex === 1" class="d-flex">
                <select class="mr-1" id="time-select" v-model="timeSelect">
                    <option value="today">{{ $t("time.today") }}</option>
                    <option value="yesterday">
                        {{ $t("time.yesterday") }}
                    </option>
                    <option value="current-week">
                        {{ $t("time.currentWeek") }}
                    </option>
                    <option value="last-week">{{ $t("time.lastWeek") }}</option>
                    <option value="current-month">
                        {{ $t("time.currentMonth") }}
                    </option>
                    <option value="last-month">
                        {{ $t("time.lastMonth") }}
                    </option>
                    <option value="last-30">{{ $t("time.last30Day") }}</option>
                    <option value="all-time">{{ $t("time.allTime") }}</option>
                </select>
            </div>
            <div v-else class="chatListSettingContainer">
                <select id="topic-select" v-model="selectedTopic">
                    <option value="all">{{ $t("message.allTags") }}</option>
                    <option v-for="topic in topics" :value="topic">
                        {{ topic }}
                    </option>
                </select>
                <div
                    v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                    :content="$t('message.showMyChats')"
                    class="custom-checkbox2"
                    style="margin-left: 6px"
                >
                    <a-switch v-model="showMyTicket" size="small">
                        <a-icon slot="checkedChildren" type="check" />
                        <a-icon slot="unCheckedChildren" type="close" />
                    </a-switch>
                    <span>{{ $t("message.showMyChats") }}</span>
                </div>
                <a-button
                    @click="showModal"
                    v-if="tabIndex === 0"
                    class="actionButtonBreadcrumb"
                    style="margin-right: 8px"
                >
                    <md-icon>add</md-icon>
                    {{ $t("message.addNewStatus") }}
                </a-button>
                <a-button
                    @click="statusShowModal"
                    v-if="tabIndex === 0"
                    class="actionButtonBreadcrumb"
                    style="margin-right: 8px"
                >
                    {{ $t("message.listStatuses") }}
                </a-button>
            </div>
        </AppBreadCrumb>
        <div class="position-relative pt-3" style="padding: 0 30px">
            <a-row>
                <a-col span="12" style="margin-bottom: 10px">
                    <div class="d-flex">
                        <a-button
                            :class="{
                                'menu-button': tabIndex !== 0,
                                'selected-link': tabIndex === 0,
                            }"
                            class="menu-button-base"
                            @click="tabIndex = 0"
                        >
                            <OfflineSupWaiting
                                :fill="tabIndex === 0 ? '#03a9f4' : '#808184'"
                                style="margin-bottom: -1px; width: 1.25em; margin-right: 1em"
                            />
                            <span style="margin-left: 4px">{{ $t("message.waitingReply") }}</span>
                        </a-button>

                        <a-button
                            :class="{
                                'menu-button': tabIndex !== 1,
                                'selected-link': tabIndex === 1,
                            }"
                            class="menu-button-base"
                            @click="tabIndex = 1"
                        >
                            <ArchiveIcon
                                :fill="tabIndex === 1 ? '#03a9f4' : '#808184'"
                                style="margin-bottom: -1px; width: 1.25em; margin-right: 1em"
                            />
                            <span style="margin-left: 4px">{{ $t("message.archive") }}</span>
                        </a-button>
                        <a-button
                            :class="{
                                'menu-button': tabIndex !== 2,
                                'selected-link': tabIndex === 2,
                            }"
                            class="menu-button-base"
                            @click="tabIndex = 2"
                        >
                            <ArchiveIcon
                                :fill="tabIndex === 2 ? '#03a9f4' : '#808184'"
                                style="margin-bottom: -1px; width: 1.25em; margin-right: 1em"
                            />
                            <span style="margin-left: 4px">{{ $t("ticket.ticketForwarding") }}</span>
                        </a-button>
                    </div>
                </a-col>
                <a-col span="24">
                    <div v-if="tabIndex === 0">
                        <AwaitingTickets :show-my-tickets="showMyTicket" :tag="selectedTopic" :statuses="statuses" />
                    </div>
                    <div v-if="tabIndex === 1">
                        <TicketHistory :timeSelect="timeSelect" :statuses="statuses" />
                    </div>
                    <div
                        v-if="tabIndex === 2 && checkPermission(PERMISSION_TYPES['offlineSupportRequest.get'].tr.name)"
                    >
                        <TicketForwarding />
                    </div>
                </a-col>
            </a-row>
        </div>

        <Modal2
            v-if="isModalShow"
            id="ticket-status-form"
            class="ticket-status-form"
            :show-footer="false"
            @cancel="hideModal"
            :title="ticketFormMode ? $t('message.ticketStatusForm') : $t('message.listStatuses')"
        >
            <div v-if="ticketFormMode">
                <b-form class="d-flex flex-column justify-content-center" @submit.prevent="handleSave">
                    <b-row>
                        <b-col md="12">
                            <b-row>
                                <b-col md="12">
                                    <b-form-group :label="$t('message.statusFormTitle')">
                                        <b-form-input
                                            v-model="statusForm.title"
                                            :name="$t('message.statusFormTitle')"
                                            autocomplete="off"
                                            trim
                                            type="text"
                                        />
                                    </b-form-group>
                                </b-col>
                                <b-col md="12" id="buttons">
                                    <b-button @click="hideModal">
                                        {{ $t("message.cancel") }}
                                    </b-button>
                                    <b-button type="submit" variant="primary" @submit.prevent="handleSave">
                                        <span v-if="!statusForm._id">
                                            {{ $t("message.save") }}
                                        </span>
                                        <span v-else>
                                            {{ $t("message.update") }}
                                        </span>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-form>
            </div>
            <div v-else>
                <StatusTable :statuses="statuses" @edit="editStatus" @deleted="deleted" />
            </div>
        </Modal2>

        <ChatBar v-if="!isAdmin" :visible="false" />
    </div>
</template>

<script>
import OSRWaitingAnswer from "../../components/svg/OSRWaitingAnswer";
import ArchiveIcon from "../../components/svg/ArchiveIcon";
import AppBreadCrumb from "../../components/common/AppBreadCrumb";
import OfflineSupWaiting from "../../components/svg/OfflineSupWaiting";
import AwaitingTickets from "../../components/AwaitingTickets";
import TicketHistory from "../../components/TicketHistory";
import { mapActions, mapState, mapGetters } from "vuex";
import ChatBar from "../../components/ChatBar";
import StatusTable from "../../components/StatusTable";
import TicketForwarding from "../../components/TicketForwarding";
import { createTicketStatus, readTicketStatus, updateTicketStatus } from "../../api/ticket";
import _ from "lodash";
import Modal2 from "../../components/common/Modal2.vue";
import { PERMISSION_TYPES } from "../../language/permissionTypes";

export default {
    name: "Ticket",
    data() {
        return {
            timeSelect: "today",
            tabIndex: 0,
            selectedTopic: "all",
            showMyTicket: false,
            statusForm: {
                title: "",
            },
            statuses: [],
            ticketFormMode: true,
            isModalShow: false,
        };
    },
    components: {
        AppBreadCrumb,
        OSRWaitingAnswer,
        ArchiveIcon,
        OfflineSupWaiting,
        AwaitingTickets,
        TicketHistory,
        ChatBar,
        TicketForwarding,
        StatusTable,
        Modal2,
    },
    computed: {
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapState({
            isAdmin: (state) => state.auth.adminUser != null,
            topics: (state) => state.ticket.topics,
        }),
    },
    methods: {
        ...mapActions({
            fetchTopics: "ticket/fetchTopics",
        }),
        showModal() {
            this.isModalShow = true;
            this.ticketFormMode = true;
        },
        statusShowModal() {
            this.isModalShow = true;
            this.ticketFormMode = false;
        },
        hideModal() {
            this.isModalShow = false;
            this.reset();
        },

        reset() {
            this.ticketFormMode = true;
            this.statusForm = {
                title: "",
            };
        },
        handleSave() {
            if (this.statusForm.title === "") {
                this.isModalShow = true;
            } else {
                if (!!this.statusForm._id)
                    updateTicketStatus(this.statusForm).then(({ data }) => {
                        this.statuses = this.statuses.map((x) => {
                            if (x._id === data._id) return data;
                            return x;
                        });
                        this.reset();
                        this.ticketFormMode = false;
                        this.isModalShow = false;
                    });
                else
                    createTicketStatus(this.statusForm).then(({ data }) => {
                        this.statuses.push(data);
                        /*this.$bvModal.hide("ticket-status-form");*/
                        this.reset();
                        this.isModalShow = false;
                    });
            }
        },
        editStatus(id) {
            let maybeStatus = this.statuses.find((x) => x._id === id);
            if (!maybeStatus) return;
            this.statusForm = _.clone(maybeStatus);
            this.ticketFormMode = true;
        },
        deleted(id) {
            this.statuses = this.statuses.filter((x) => x._id !== id);
        },
    },
    mounted() {
        this.fetchTopics();
        readTicketStatus().then(({ data }) => {
            this.statuses = data;
        });
    },
};
</script>
<style>
.align-items-end {
    align-items: center !important;
}
</style>

<style lang="scss" scoped>
#ticket-component {
    #time-select,
    #topic-select {
        border: none;
        background-color: #f3f6f9;
        padding: 3px 10px;
        border-radius: 6px;
        font-size: 12px;
        font-family: Poppins;
        font-weight: bolder;
        color: #3699ff;
        min-width: 130px;
    }

    .selected-link {
        color: #03a9f4;
        border: none;
        border-radius: initial;
        border-bottom: 2px solid #03a9f4;
        margin-right: 4px;
    }

    svgIcon {
        fill: #03a9f4;
    }

    svgIconTabChange {
        fill: #808184;
    }

    .menu-button {
        margin-right: 4px;
        border: none;
    }

    .menu-button-base {
        background: transparent !important;
    }

    .custom-checkbox2 {
        background-color: #f3f6f9;
        border-radius: 6px;
        padding: 4px 6px;
        max-width: 120px;
        width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        font-family: Poppins;
        font-weight: 400;
        font-size: 12px;
        color: #1e1e2d;
    }

    .chatListSettingContainer {
        display: flex;
        justify-content: left;
        width: 40%;
        position: absolute;
        margin-top: 2px;
        z-index: 50;

        div {
            margin-right: 10px;
        }
    }
}

#buttons {
    display: flex;
    justify-content: flex-end;
    gap: 7px;
}
</style>
